import React from 'react';
import { Layout } from "antd";
import ForgotPasswordPage from '../components/login/ForgetPasswordComponent';

export default function Login() {
    return (
        <Layout style={{ minHeight: "100vh" }}>
            <ForgotPasswordPage />
        </Layout>
    );
}